import React, { Component } from 'react';
import SearchInput, {createFilter} from 'react-search-input'
import { connect } from 'react-redux'
import { setSearchData } from '../../actions/search';
import {FormGroup, Label, Input} from 'reactstrap';

class Search extends Component {

	constructor (props, context) {
	    super(props, context)
	    this.state = {
	      searchTerm: '',
		  data: false,
		  objectFilters: {}
	    }
	    this.searchUpdated = this.searchUpdated.bind(this)
	    this.KEYS_TO_FILTERS = this.props.keys_to_filter;
	    this.data = this.props.data;
  	}

	componentDidUpdate(pre) {

		if ( !this.props.ignoreSearchScope ) {
			const searchScope = localStorage.getItem('searchScope');
			let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
			if ( searchScope ) {
					if ( this.state.searchTerm ) {
						jsonData = {
							...jsonData,
							[searchScope] : {
								...jsonData[searchScope],
								searchTerm : this.state.searchTerm
							}
						}


					} else {
						jsonData = {
							...jsonData,
							[searchScope] : {
								...jsonData[searchScope],
								searchTerm : ''
							}
						}
					}

					if ( this.state.objectFilters ) {
						jsonData = {
							...jsonData,
							[searchScope] : {
								...jsonData[searchScope],
								objectFilters : {
									...this.state.objectFilters
								}
							}
						}
					}
					localStorage.setItem('scopedSearchData', JSON.stringify(jsonData));
			}

			if ( JSON.stringify(this.props.data) !== JSON.stringify(this.data) ) {
				this.data = this.props.data;

				if ( this.state.searchTerm ) {
					console.log("data changed, we need to search again..");
					this.searchUpdated(this.state.searchTerm);
				}
			}
		}

	}

	componentDidMount() {
		if ( !this.props.ignoreSearchScope ) {
			const searchScope = localStorage.getItem('searchScope');
			let state = {
				...this.state
			}
			if ( searchScope ) {
				let jsonData = JSON.parse(localStorage.getItem('scopedSearchData'));
				if ( jsonData ) {
					if ( jsonData[searchScope] ) {
						this.setState({
							...this.state,
							...jsonData[searchScope]
						}, this.searchUpdated)
					}
				}
			}
		}
	}

  	searchUpdated(term = false, objectFilters = false, filterArrayKey = false) {

		if(term !== false) {
			this.setState({searchTerm: term})
		}

		let data = this.data;

		  if(objectFilters){
			  if(this.state.objectFilters[filterArrayKey]) {
				  let state = this.state;
				  delete state.objectFilters[filterArrayKey];

				  this.setState(state);

				  data = this.filterByProps(data, state.objectFilters);
			  }else{
				  this.setState({
					  objectFilters: {
						  ...this.state.objectFilters,
						  [filterArrayKey] : {
							  filterKey : objectFilters.key,
							  filterValue : objectFilters.value
						  }
					  }

				  })


				  let objectFiltersObj = this.state.objectFilters;
				  objectFiltersObj[filterArrayKey] = {
					  filterKey : objectFilters.key,
					  filterValue : objectFilters.value
				  }

				  data = this.filterByProps(data, objectFiltersObj);
			  }


		  }else if(Object.keys(this.state.objectFilters).length > 0) {
			 
			  data = this.filterByProps(data, this.state.objectFilters);
		  }





		  if(term || this.state.searchTerm) {
			  if ( data ) {
				  data = data.filter(createFilter(this.state.searchTerm, this.KEYS_TO_FILTERS))
			  }

		  }


      this.props.updateSearchData(data);


  	}

	filterByProps(data, objectFilters) {
		let filteredData = [];
		let total = [];
		let endResult = [];

		if(Object.keys(objectFilters).length <= 0) {
			return data;
		}

		Object.keys(objectFilters).map(function(key, value) {

			let searchKey = objectFilters[key]['filterKey'];
			let searchValue = objectFilters[key]['filterValue'];

			let filters = data.filter(function(data) {
				return data[searchKey] == searchValue ? true : false;
			})

			filteredData.push(filters);
		})

		for(let i = 0; i <= filteredData.length; i++) {
			if(filteredData[i]) {
				for(let j = 0; j <= filteredData[i].length; j++) {
					if(filteredData[i][j]) {
						endResult.push(filteredData[i][j]);
					}
				}
			}
		}


		return endResult;
	}



	mapFilters(filter, key) {
		switch(this.props.filters[filter]['type']) {
			case 'checkbox':
				return (
					<FormGroup key={key} >
			          <Label>
			            <Input onChange={(e) => this.searchUpdated(false, this.props.filters[filter], this.props.filters[filter]['key']+'_'+this.props.filters[filter]['value'])} type="checkbox" checked={this.state.objectFilters[this.props.filters[filter]['key'] + '_' + this.props.filters[filter]['value']] ? true : false} name={this.props.filters[filter]['key']} lookfor={this.props.filters[filter]['value']} />
						&nbsp;{this.props.filters[filter]['name']}
			          </Label>
			        </FormGroup>
				)
		}
	}

  	render() {

  		return (
  			<div>
				<div className="filter-holder">{this.props.filters ? Object.keys(this.props.filters).map((filter, key) => this.mapFilters(filter, key)) : ''}</div>
  				<SearchInput placeholder="Zoeken" className="search-input" inputClassName="search-input" value={this.state.searchTerm} onChange={this.searchUpdated} />
  			</div>
  		)
  	}


}
function mapStateToProps(state, ownProps) {

    return {
        searchData: state.SearchDataReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search)



// WEBPACK FOOTER //
// ./src/components/Search/index.js